import { styled } from "@mui/material";

const GrowingContainer = styled('div')(({upScale = 1.1}) => ({
    transition: 'all 0.3s ease-in-out',
    '&:hover': {
        scale: upScale
    }
}));

export default GrowingContainer;